<template>
  <div class="container">
    <!-- <div class="rserves_head" v-show="payover==0">
      <div class="head">
        <div class="head__fixed">
          <div class="head__fixed__box">
            <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="backOld"></a></div>
            <div class="header__fixed__center">
              <div class="enname">{{simpleStadium.en_name}}</div>
              <div class="chname">{{simpleStadium.name}}</div>
            </div>
            <div class="header__fixed__right">
              <a class="switch"></a>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="res_head" v-show="payover==0">
      <div class="res_head__fixed">
        <div class="res_head__fixed__box">
          <div class="res_header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="res_header__fixed__center">
            <div class="enname">{{simpleStadium.en_name}}</div>
            <div class="chname">{{simpleStadium.name}}</div>
          </div>
          <div class="res_header__fixed__right"></div>
        </div>
      </div>
    </div>

    <div class="sell_rserves_hpage" v-show="payover==0">
      <div class="sell_rserves_hpage_fit_tab">
        <van-tabs v-model="active" line-width='22vw' title-active-color="#444054" title-inactive-color="#DDDDDD" class="sell_rserves_hpage_fit_tab_tab">
          <van-tab title="酒店服务">
            <div class="sell_rserves_hpage_fit_tab_servers">
              <div class="sell_rserves_hpage_fit_tab_servers_address">{{simpleStadium.address}}</div>
              <div class="sell_rserves_hpage_fit_tab_servers_tips">
                <div v-for="itemValue in servicesList" @click="showServesDes(itemValue)">
                  <img :src="servicesimg[itemValue]" />
                  {{services[itemValue]}}
                </div>
              </div>
              <div style="clear: both;"></div>
              <div class="sell_rserves_hpage_fit_tab_des_Tip" v-show="sell_tabdesTips">{{sell_tabdesTips_txt}}</div>
            </div>
          </van-tab>
          <van-tab title="酒店描述">
            <div class="sell_rserves_hpage_fit_tab_des" v-html="simpleStadium.introduce"></div>
          </van-tab>
          <van-tab title="营业时间">
            <div class="sell_rserves_hpage_fit_tab_des" v-html="simpleStadium.business_time"></div>
          </van-tab>
          <van-tab title="预约说明">
            <div class="sell_rserves_hpage_fit_tab_des" v-html="simpleStadium.book_tip"></div>
          </van-tab>
        </van-tabs>
      </div>
      <div class="sell_rserves_hpage_fit_order">
        <div class="sell_rserves_hpage_fit_order_info sell_rserves_hpage_fit_order_top sell_bb_rserves_hpage_fit_order_top">
          <div class="sell_rserves_hpage_fit_order_info_block">
            <div class="sell_rserves_hpage_fit_order_info_block_myinfo">
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_title">预约类型</div>
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_value">沸健身 (高端酒店游泳健身)</div>
              <div class="clearboth"></div>
            </div>
            <div class="sell_rserves_hpage_fit_order_info_block_myinfo">
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_title">日期</div>
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_value">{{weekDate}}&nbsp;&nbsp;{{orderDate}}</div>
              <div class="clearboth"></div>
            </div>
            <div class="sell_rserves_hpage_fit_order_info_block_myinfo">
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_title">到店时间</div>
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_value_arriveTime" @click="vt_showSelectPickTime()">{{vt_showSelectPickTimeTXT}}<label></label></div>
              <div class="clearboth"></div>
            </div>
            <div class="sell_rserves_hpage_fit_order_info_block_myinfo">
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_title">姓名</div>
              <!-- <input class="sell_rserves_hpage_fit_order_info_block_myinfo_value sell_rserves_hpage_fit_order_info_block_myinfo_value_small" type="text" maxlength="12" v-model="sell_username" placeholder="务必填写真实姓名, 入场需出示身份证" style="color: #F7B500;"  /> -->
              <input v-if="sell_username==''" class="sell_rserves_hpage_fit_order_info_block_myinfo_value sell_rserves_hpage_fit_order_info_block_myinfo_value_small" type="text" maxlength="12" v-model="sell_username" placeholder="务必填写真实姓名, 入场需出示身份证" />
              <div v-else class="sell_rserves_hpage_fit_order_info_block_myinfo_value">{{sell_username}}</div>
              <div class="clearboth"></div>
            </div>
            <div class="sell_rserves_hpage_fit_order_info_block_myinfo">
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_title">手机号</div>
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_value">{{userinfo.mobile}}</div>
              <!-- <input type="tel"maxlength="11" v-model="sell_phone" placeholder="务必填写真实手机号" class="sell_rserves_hpage_fit_order_info_block_myinfo_value" style="color: #F7B500;" /> -->
              <div class="clearboth"></div>
            </div>
          </div>
        </div>
        <!-- 价格 -->
        <div class="sell_rserves_hpage_fit_order_price rserves_hpage_fit_order_priceS">
          <div class="sell_rserves_hpage_fit_order_price_block">
            <van-row class="sell_rserves_hpage_fit_order_price_block_item">
              <van-col span="12" class="sell_rserves_hpage_fit_order_price_block_item_title">
                价格
              </van-col>
              <van-col span="12" class="sell_rserves_hpage_fit_order_price_block_item_cont">
                <div class="sell_rserves_hpage_fit_order_price_block_viprice sell_rserves_hpage_fit_order_price_block_vipriceB">门市价&nbsp;¥{{simpleStadium.origin_price_sel}}/人</div>
              </van-col>
            </van-row>
            <van-row class="sell_rserves_hpage_fit_order_price_block_totalPrice">
              <van-col span="12" class="sell_rserves_hpage_fit_order_price_block_totalPrice_left">
                <!-- 秒杀价 -->
                &nbsp;
              </van-col>
              <van-col span="12" class="sell_rserves_hpage_fit_order_price_block_totalPrice_right">
                ¥{{simpleStadium.real_pay_sel}}
              </van-col>
            </van-row>
            <van-row class="sell_rserves_hpage_fit_order_price_block_total">
              <van-col span="24" class="sell_rserves_hpage_fit_order_price_block_total_align">
                本次预约为您节省¥{{simpleStadium.real_savefee_sel}}元
                <!-- <div>本次预约为您节省本次预约为您节省本次预</div> -->
              </van-col>
            </van-row>
          </div>
        </div>
        <div class="sell_rserves_hpage_fit_order_submit">
          <div class="rserves_hpage_fit_order_submit_btn" @click="rserves_submit_order()">提交</div>
          <div class="rserves_hpage_fit_order_submit_tips">
            <!-- 退订说明：如需退订请提前{{vt_refund_time}}申请，过期未退订视为已使用 -->
            退订说明：参与秒杀活动的订单均不可退订
          </div>
        </div>
        <div class="sell_seat"></div>
      </div>
    </div>
    <div class="head" v-show="payover==1">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>支付成功</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>
    <div class="vision_payresult" v-show="payover==1">
      <img class="vision_payresult_img" src="../../../assets/images/base/pay_success_icon.png" />
      <div class="vision_payresult_con">
        预约成功短信已发送至手机{{userinfo.mobile}}，请注意查收！
      </div>
      <div class="vision_payresult_tip">
        注：使用时请在酒店前台出示您的验证码和本人身份证，如有疑问可咨询400-630-5888
      </div>

      <div class="vision_payresult_btn">
        <div class="vision_payresult_btn_order" @click="backOrder()">查看订单</div>
        <div class="vision_payresult_btn_index" @click="backHome()">返回首页</div>
        <div class="clearboth"></div>
      </div>
    </div>

    <div class="vt_rserves_hpage_fit_order_picktimeMask" v-show="vtRservesHpageFitOrderPicktime_wst"></div>
    <div class="vt_rserves_hpage_fit_order_picktime" v-show="vtRservesHpageFitOrderPicktime_wst">
      <van-picker title="请选择入场时间" show-toolbar :columns="wst_columns" @confirm="onConfirmwWst" @cancel="onCancelWst" />
    </div>
    <div class="vt_rserves_hpage_fit_order_picktimeMask" v-show="vtRservesHpageFitOrderPicktime_guili"></div>
    <div class="vt_rserves_hpage_fit_order_picktime" v-show="vtRservesHpageFitOrderPicktime_guili">
      <van-picker title="请选择入场时间" show-toolbar :columns="guili_columns" @confirm="onConfirmGuiLi" @cancel="onCancelGuiLi" />
    </div>
    <div class="vt_rserves_hpage_fit_order_picktimeMask" v-show="vtRservesHpageFitOrderPicktime"></div>
    <div class="vt_rserves_hpage_fit_order_picktime" v-show="vtRservesHpageFitOrderPicktime">
      <van-datetime-picker v-model="vt_pickTimeFOrEnter" type="time" title="选择时间" :min-hour="vtpicktime_minhourse" :max-hour="vtpicktime_maxhourse" :min-minute="0" :max-minute="30" :filter="vtRservesHpageFitOrderPicktime_filter" @cancel="vtPickTimeSelectCancel" @confirm="vtPickTimeSelect" />
    </div>
    <!-- <img src="../../../assets/images/base/hotel_park.png" /> -->
  </div>
</template>
<script>
  import {
    isPhone
  } from "../../../lib/utils.js"
  export default {
    data() {
      return {
        active:0,
        simpleStadium:{},
        vt_showSelectPickTimeTXT:'请选择到店时间',
        orderDate:'',
        userinfo:{},
        sell_username:'',
        weekDate:'',
        userPayStatus:0,
        servicesimg: {
          "101": require('../../../assets/images/base/hotel_park.png'),
          "102": require('../../../assets/images/base/hotel_park_money.png'),
          "103": require('../../../assets/images/base/hotel_bathing.png'),
          "104": require('../../../assets/images/base/hotel_bathing_money.png'),
          "105": require('../../../assets/images/base/hotel_wardrobe.png'),
          "106": require('../../../assets/images/base/hotel_wardrobe_money.png'),
          "107": require('../../../assets/images/base/hotel_eating.png'),
          "108": require('../../../assets/images/base/hotel_eating_money.png'),
          "109": require('../../../assets/images/base/hotel_coach.png'),
          "110": require('../../../assets/images/base/hotel_coach_money.png'),
          "111": require('../../../assets/images/base/hotel_shopping.png'),
          "112": require('../../../assets/images/base/hotel_wifi.png'),
          "113": require('../../../assets/images/base/hotel_rent.png'),
          "114": require('../../../assets/images/base/hotel_pool.png'),
          "115": require('../../../assets/images/base/hotel_power_equipment.png'),
          "116": require('../../../assets/images/base/hotel_practicehouse.png'),
          "118": require('../../../assets/images/base/hotel_park.png'),
          // "117": "住宿"
        },
        services: {
          "101": "免费停车",
          "102": "收费停车",
          "103": "免费洗浴",
          "104": "收费洗浴",
          "105": "免费衣柜",
          "106": "收费衣柜",
          "107": "免费餐饮",
          "108": "收费餐饮",
          "109": "免费教练",
          "110": "收费教练",
          "111": "购物",
          "112": "WIFI",
          "113": "器具租赁",
          "114": "游泳池",
          "115": "力量器械",
          "116": "练操房",
          // "117": "住宿"
          "118":"限时免费停车",
        },
        servicesList:[],
        vtRservesHpageFitOrderPicktime_wst:false,
        vtRservesHpageFitOrderPicktime_guili:false,
        vtRservesHpageFitOrderPicktime:false,
        guili_columns:['06:30','08:30','10:30','12:30','14:30','16:30','18:30','20:30'],
        wst_columns:['06:00','08:30','11:00','13:30','16:00','18:30','21:00'],
        vtpicktime_minhourse:0,
        vtpicktime_maxhourse:0,
        vt_pickTimeFOrEnter:'',
        payover:0,//0：隐藏， 1：显示

        sell_tabdesTips:false,
        sell_tabdesTips_txt:'',
        delaySetTimeOut: null,
        sell_phone:''
      }
    },
    created() { },
    mounted() {
      this.loadData()
      this.getUserInfo()
      sessionStorage.setItem('hotsellLoad','yes')
      //
      // // console.log(JSON.parse(sessionStorage.getItem('hotsell_create')))
      // // console.log(JSON.parse(sessionStorage.getItem('hotsellParam')))
      this.userPayStatus=(JSON.parse(sessionStorage.getItem('hotsellParam'))).userPayStatus
    },
    methods: {
      showServesDes(item){
        var $this=this
        // console.log(item)
        var service_des=JSON.parse(this.simpleStadium.service_des)
        // console.log(service_des)
        // console.log(service_des[item])
        clearTimeout(this.delaySetTimeOut)
        if(service_des[item]==null||service_des[item]==undefined||service_des[item]==''){
          // sell_tabdesTips:false,
          // sell_tabdesTips_txt:''
          this.sell_tabdesTips=false
          this.sell_tabdesTips_txt=''
        }else{
          this.sell_tabdesTips=true
          this.sell_tabdesTips_txt=service_des[item]
          this.delaySetTimeOut = setTimeout(function() {
            $this.sell_tabdesTips=false
          }, 5000)
        }
      },
      backOrder() {
        this.$router.push({
          name: "orderlist"
        });
      },
      backHome() {
        this.$router.push({
          path: "/"
        });
      },
      vt_showSelectPickTime(){
        // console.log(this.simpleStadium)
        if(this.simpleStadium.stadium_id=='100050'){//100050
          if((JSON.parse(sessionStorage.getItem('hotsellParam'))).datatype=='today'){
            var date=new Date()
            if(date.getHours()<11&&date.getMinutes()<30){
              this.guili_columns.splice(0,3)
            }else if(date.getHours()<11&&date.getMinutes()>=30){
              this.guili_columns.splice(0,4)
            }else if(date.getHours()<13&&date.getMinutes()<30){
              this.guili_columns.splice(0,4)
            }else if(date.getHours()<13&&date.getMinutes()>=30){
              this.guili_columns.splice(0,5)
            }else if(date.getHours()<15&&date.getMinutes()<30){
              this.guili_columns.splice(0,5)
            }else if(date.getHours()<15&&date.getMinutes()>=30){
              this.guili_columns.splice(0,6)
            }
            this.vtRservesHpageFitOrderPicktime_guili=true
          }else{
            this.vtRservesHpageFitOrderPicktime_guili=true
          }

        }else if(this.simpleStadium.stadium_id=='100045'){//
          // console.log(this.simpleStadium.stadium_id)
          if((JSON.parse(sessionStorage.getItem('hotsellParam'))).datatype=='today'){
            var date=new Date()
            if(date.getHours()<12){
              this.wst_columns.splice(0,3)
            }else if(date.getHours()<14&&date.getMinutes()<30){
              this.wst_columns.splice(0,4)
            }else if(date.getHours()<14&&date.getMinutes()>=30){
              this.wst_columns.splice(0,4)
            }else if(date.getHours()<15&&date.getMinutes()<30){
              this.wst_columns.splice(0,5)
            }else{
              this.wst_columns.splice(0,6)
            }
            this.vtRservesHpageFitOrderPicktime_wst=true
          }else{
            this.vtRservesHpageFitOrderPicktime_wst=true
          }
        }else{
          this.vtRservesHpageFitOrderPicktime=true
          // console.log(1)
        }
      },
      vtPickTimeSelectCancel(){
        this.vtRservesHpageFitOrderPicktime=false
      },
      vtPickTimeSelect(e){
        // console.log(e)
        this.vt_showSelectPickTimeTXT=e
        this.vtRservesHpageFitOrderPicktime=false
      },
      vtRservesHpageFitOrderPicktime_filter(type, options){
        if (type === 'minute') {
          return options.filter(option => option % 30 === 0);
        }
        return options;
      },
      onConfirmwWst(value, index){
        this.vt_showSelectPickTimeTXT=value
        this.vtRservesHpageFitOrderPicktime_wst=false
      },
      onCancelWst(){
        this.vtRservesHpageFitOrderPicktime_wst=false
      },
      onConfirmGuiLi(value, index){
        // console.log(value)
        // console.log(index)
        this.vt_showSelectPickTimeTXT=value
        this.vtRservesHpageFitOrderPicktime_guili=false
      },
      onCancelGuiLi(){
        // console.log('onCancelGuiLi')
        this.vtRservesHpageFitOrderPicktime_guili=false
      },
      loadData(){
        var $this = this
        this.userPayStatus=(JSON.parse(sessionStorage.getItem('hotsellParam'))).userPayStatus
        if((JSON.parse(sessionStorage.getItem('hotsellParam'))).datatype=='today'){
          var date = new Date();
          var dateY=date.getFullYear();
          var dateM=date.getMonth()+1;
          if(dateM<10){dateM='0'+dateM}
          var dateD=date.getDate();
          if(dateD<10){dateD='0'+dateD}
          this.orderDate=dateY+'-'+dateM+'-'+dateD
          let week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
          this.weekDate=week[date.getDay()]+' '
        }else{
          var timp= new Date().getTime() + 24*60*60*1000
          var date = new Date(timp);
          var dateY=date.getFullYear();
          var dateM=date.getMonth()+1;
          if(dateM<10){dateM='0'+dateM}
          var dateD=date.getDate();
          if(dateD<10){dateD='0'+dateD}
          this.orderDate=dateY+'-'+dateM+'-'+dateD
          let week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
          this.weekDate=week[date.getDay()]+' '
        }
        var param=JSON.parse(sessionStorage.getItem('hotsellParam'))
        var params={
          token: localStorage.getItem("token"),
          stadium_id:param.stadium
        }

        // ==============
        var qs = require('qs');
        let url = this.api.userApi.getStadiumDetailVersionTwo
        this.axios.post(url, qs.stringify(params), )
        .then((result) => {
          // console.log(result)
          if (result.data) {
            result.data.origin_price_sel=(result.data.origin_price/100).toFixed(2)
            if($this.userPayStatus==1){
              result.data.real_pay_sel=(JSON.parse(sessionStorage.getItem('hotsell_create'))).vip_gold_fee
            }else if($this.userPayStatus==2){
              result.data.real_pay_sel=(JSON.parse(sessionStorage.getItem('hotsell_create'))).vip_pt_fee
            }else if($this.userPayStatus==3){
              result.data.real_pay_sel=(JSON.parse(sessionStorage.getItem('hotsell_create'))).vip_diamond_fee
            }else{
              result.data.real_pay_sel=(JSON.parse(sessionStorage.getItem('hotsell_create'))).other_fee
            }
            result.data.real_savefee_sel=(parseFloat(result.data.origin_price_sel,10)-parseFloat(result.data.real_pay_sel,10)).toFixed(2)
            $this.simpleStadium=result.data
            if (result.data.service == '' || result.data.service == null || result.data.service == undefined) {
              $this.servicesList = []
            } else {
              $this.servicesList = result.data.service.split(',')
            }
            // servicesList
            if((JSON.parse(sessionStorage.getItem('hotsellParam'))).datatype=="today"){
              // console.log('today')
              // console.log(new Date().getHours()+":"+new Date().getMinutes())
              var temp=new Date().getHours()
              if(new Date().getMinutes()<=30){
                temp=temp+2
              }else{
                temp=temp+3
              }
              // console.log(temp+":00")
              if(result.data.business_start_time==null||result.data.business_start_time==undefined||result.data.business_start_time==''){
                if(temp>10){
                  var b=temp
                  // console.log(b)
                  if(b>=17){
                    b=17
                  }
                  $this.vtpicktime_minhourse=b
                  $this.vt_pickTimeFOrEnter=b+":00"
                }else{
                  $this.vtpicktime_minhourse=10
                  $this.vt_pickTimeFOrEnter="10:00"
                }
              }else{
                var stime=temp//(result.data.business_start_time).substring(0,2)
                // console.log(parseInt(stime,10))
                $this.vtpicktime_minhourse=parseInt(stime,10)
              }
            }else{
              // console.log('tomorrow')
              if(result.data.business_start_time==null||result.data.business_start_time==undefined||result.data.business_start_time==''){
                $this.vtpicktime_minhourse=10
                $this.vt_pickTimeFOrEnter="10:00"
              }else{
                var stime=(result.data.business_start_time).substring(0,2)
                // console.log(parseInt(stime,10))
                $this.vtpicktime_minhourse=parseInt(stime,10)
              }
            }
            if(result.data.business_end_time==null||result.data.business_end_time==undefined||result.data.business_end_time==''){
              $this.vtpicktime_maxhourse=17
            }else{
              var etime=(result.data.business_end_time).substring(0,2)
              // console.log(parseInt(etime,10))
              var litime=parseInt(etime,10) - 2
              $this.vtpicktime_maxhourse=litime
            }
          } else {
            $this.$toast(result.msg);
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$toast('error');
        })
        return
        // ==============


        // this.$api.hsstadiumDetail(params).then(result => {
        //   result.data.origin_price_sel=(result.data.origin_price/100).toFixed(2)
        //   if($this.userPayStatus==1){
        //     result.data.real_pay_sel=(JSON.parse(sessionStorage.getItem('hotsell_create'))).vip_gold_fee
        //   }else if($this.userPayStatus==2){
        //     result.data.real_pay_sel=(JSON.parse(sessionStorage.getItem('hotsell_create'))).vip_pt_fee
        //   }else if($this.userPayStatus==3){
        //     result.data.real_pay_sel=(JSON.parse(sessionStorage.getItem('hotsell_create'))).vip_diamond_fee
        //   }else{
        //     result.data.real_pay_sel=(JSON.parse(sessionStorage.getItem('hotsell_create'))).other_fee
        //   }
        //   result.data.real_savefee_sel=(parseFloat(result.data.origin_price_sel,10)-parseFloat(result.data.real_pay_sel,10)).toFixed(2)
        //   $this.simpleStadium=result.data
        //   if (result.data.service == '' || result.data.service == null || result.data.service == undefined) {
        //     $this.servicesList = []
        //   } else {
        //     $this.servicesList = result.data.service.split(',')
        //   }
        //   // servicesList
        //   if((JSON.parse(sessionStorage.getItem('hotsellParam'))).datatype=="today"){
        //     // console.log('today')
        //     // console.log(new Date().getHours()+":"+new Date().getMinutes())
        //     var temp=new Date().getHours()
        //     if(new Date().getMinutes()<=30){
        //       temp=temp+2
        //     }else{
        //       temp=temp+3
        //     }
        //     // console.log(temp+":00")
        //     if(result.data.business_start_time==null||result.data.business_start_time==undefined||result.data.business_start_time==''){
        //       if(temp>10){
        //         var b=temp
        //         // console.log(b)
        //         if(b>=17){
        //           b=17
        //         }
        //         $this.vtpicktime_minhourse=b
        //         $this.vt_pickTimeFOrEnter=b+":00"
        //       }else{
        //         $this.vtpicktime_minhourse=10
        //         $this.vt_pickTimeFOrEnter="10:00"
        //       }
        //     }else{
        //       var stime=temp//(result.data.business_start_time).substring(0,2)
        //       // console.log(parseInt(stime,10))
        //       $this.vtpicktime_minhourse=parseInt(stime,10)
        //     }
        //   }else{
        //     // console.log('tomorrow')
        //     if(result.data.business_start_time==null||result.data.business_start_time==undefined||result.data.business_start_time==''){
        //       $this.vtpicktime_minhourse=10
        //       $this.vt_pickTimeFOrEnter="10:00"
        //     }else{
        //       var stime=(result.data.business_start_time).substring(0,2)
        //       // console.log(parseInt(stime,10))
        //       $this.vtpicktime_minhourse=parseInt(stime,10)
        //     }
        //   }
        //   if(result.data.business_end_time==null||result.data.business_end_time==undefined||result.data.business_end_time==''){
        //     $this.vtpicktime_maxhourse=17
        //   }else{
        //     var etime=(result.data.business_end_time).substring(0,2)
        //     // console.log(parseInt(etime,10))
        //     var litime=parseInt(etime,10) - 2
        //     $this.vtpicktime_maxhourse=litime
        //   }
        //   // console.log(result)
        // }, err => {

        // })
      },
      getUserInfo(){
        var $this = this
        let param = {
          token: localStorage.getItem("token")
        }

        var qs = require('qs');
        let url = this.api.userApi.getInfo
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          if (result.data) {
            $this.userinfo =result.data.user
            $this.sell_phone=result.data.user.mobile
            if(result.data.user.name==''||result.data.user.name==undefined||result.data.user.name==null){
              $this.sell_username=''
            }else{
              $this.sell_username=result.data.user.name
            }
          } else {
            $this.$toast(result.msg);
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$toast('error');
        })


        // this.$api.getUserInfo(param).then(result => {
        //   // console.log(result)
        //   if (result.data) {
        //     $this.userinfo =result.data.user
        //     // if(result.data.user.name==''||result.data.user.name==undefined||result.data.user.name==null){
        //     //   $this.sell_username=''
        //     // }else{
        //     //   $this.sell_username=result.data.user.name
        //     // }
        //   } else {
        //     this.$toast(result.msg)
        //   }
        // }, err => {
        //   // return
        // })
      },
      rserves_submit_order(){
        if(this.vt_showSelectPickTimeTXT=='请选择到店时间'){
          this.$toast('请选择到店时间');
          return
        }
        var $this=this
        if(!isPhone(this.sell_phone)){
          this.$toast('请填写有效手机号');
          return
        }
        if(this.sell_username.length==0){
          this.$toast('请填写用户姓名');
          return
        }
        var param={
          token: localStorage.getItem("token"),
          stadium_id:this.simpleStadium.stadium_id,
          date:this.orderDate,
          time:this.vt_showSelectPickTimeTXT,
          name:this.sell_username,
          mobile:this.sell_phone
        }
        // console.log(param)
        // return
        this.$dialog.confirm({
          message: "参与秒杀活动的订单均不可退订，请确认是否要继续预约",
          cancelButtonText:"再逛逛",
          confirmButtonText:'继续预约',
          confirmButtonColor: '#544590'
        }).then(() => {
          $this.$loading('正在提交');

          var qs = require('qs');
          let url = this.api.userApi.bookSeckillBookFit
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            console.log(result)
            if(!result.data){
              $this.$toast(result.msg);
              $this.$loading.close()
            }else{
              console.log(result)
              if (result.data.pay_json == ""||result.data.pay_json == undefined||result.data.pay_json == null) {
                $this.$toast('不用支付，直接下单完成');
              } else {

                let config = JSON.parse(result.data.pay_json);
                console.log(config)
                if (typeof WeixinJSBridge == "undefined") {
                  if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,1), false);
                  } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,1));
                    document.attachEvent('onWeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,1));
                  }
                } else {
                  $this.onBridgeReady(config,result.data.order_no,1);
                }
              }
            }
          }).catch((error) => {
            $this.$toast('未知错误，请退出重新进入');
            $this.$loading.close()
          })




          // $this.$api.hsseckillMakeOrder(param).then(result => {
          //   // console.log(result)
          //   if(!result.data){
          //     $this.$toast(result.msg);
          //     $this.$loading.close()
          //   }else{
          //     if (result.data.pay_json == ""||result.data.pay_json == undefined||result.data.pay_json == null) {
          //       $this.$toast('不用支付，直接下单完成');
          //     } else {
          //       let config = JSON.parse(result.data.pay_json);
          //       if (typeof WeixinJSBridge == "undefined") {
          //         if (document.addEventListener) {
          //           document.addEventListener('WeixinJSBridgeReady', $this.onBridgeReady(config), false);
          //         } else if (document.attachEvent) {
          //           document.attachEvent('WeixinJSBridgeReady', $this.onBridgeReady(config));
          //           document.attachEvent('onWeixinJSBridgeReady', $this.onBridgeReady(config));
          //         }
          //       } else {
          //         $this.onBridgeReady(config);
          //       }
          //     }
          //   }
          // }, err => {
          //   $this.$toast('未知错误，请退出重新进入');
          //   $this.$loading.close()
          // })
        }).catch(() => {

        })

      },
      onBridgeReady(config,order_no,type) {
        var $this = this
        WeixinJSBridge.invoke(
        'getBrandWCPayRequest', config,
        function(res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            $this.$toast("预约成功");
            $this.$loading.close()
            $this.payover=1
          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
            $this.$toast("预约取消");
            $this.$loading.close()
            $this.cancelPay(order_no,type)
          } else {
            $this.$toast("支付失败,请重新支付");
            $this.$loading.close()
          }
        });
      },
      // 取消支付，释放库存
      cancelPay(order_no,type){
        var $this = this
        let param = {
          token: localStorage.getItem("token"),
          order_no:order_no,
          // type:type
        }
        // $this.$loading('正在加载~');
        // getCouponList
        var qs = require('qs');
        let url = this.api.userApi.bookCancelPay
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
        }).catch((error) => {
          // console.warn(error)
        })
      },
    },
    destroyed: function() {}
  }
</script>
<style lang="less" scoped="scoped">
  ::-webkit-input-placeholder { color:#F7B500; }
  ::-moz-placeholder { color:#F7B500; } /* firefox 19+ */
  :-ms-input-placeholder { color:#F7B500; } /* ie */
  input:-moz-placeholder { color:#F7B500; }
  @vm_base: 1/750*100vw;
  .res_head{
  	position:relative;
  	z-index:12;
  	width:100%;
  	height:100*@vm_base;
  }
  .res_head__fixed{
  	position:fixed;
  	left:0;
  	top:0;
  	z-index:99;
  	background:#fff;
  	width:100%;
  	height:100*@vm_base;
  	.res_head__fixed__box{
  		display:flex;
  		width:100%;
  		height:100%;
  	}
  	.res_header__fixed__left,
  	.res_header__fixed__right{
  		width: 90*@vm_base;
  		height:100%;
  	}
  	.res_header__fixed__center{
  		width: calc(100% - 180*@vm_base);
  		height:100%;
  		// line-height:100*@vm_base;
  		text-align:center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  		.enname{
  		  width: 100%;
  		  color: #000000;
  		  text-align: center;
  		  font-size: 32*@vm_base;
  		  height: 40*@vm_base;
  		  line-height: 40*@vm_base;
  		  margin-top: 20*@vm_base;
  		  letter-spacing: 8*@vm_base;
  		}
  		.chname{
  		  width: 100%;
  		  color: #000000;
  		  text-align: center;
  		  font-size: 24*@vm_base;
  		  height: 24*@vm_base;
  		  line-height: 24*@vm_base;
  		  margin-top: 4*@vm_base;
  		}
  	}
    .back{
      float:left;
      width:80*@vm_base;
      height:100%;
      background:url(../../../assets/images/base/nav_back.png) center center no-repeat;
      background-size:18*@vm_base auto;
    }
    .res_switch{
      float:right;
      width:80*@vm_base;
      height:100%;
      background:url(../../../assets/images/base/Switch_photo.png) center center no-repeat;
      background-size:38*@vm_base auto;
    }
  }
  .sell_rserves_hpage{
    width: 100%;
    .van-tabs__line{
      background-color: #444054;
    }
    .sell_rserves_hpage_fit_order{
      width: 100%;
      // height: calc(100vh - 100*@vm_base + 80*@vm_base);
      background:rgba(248,248,248,1);
      width: 100%;
      overflow: hidden;
      overflow-y: auto;
      position: relative;
      .sell_rserves_hpage_fit_order_info{
        padding: 40*@vm_base 32*@vm_base 0 32*@vm_base;
        .sell_rserves_hpage_fit_order_info_block{
          padding:32*@vm_base;
          background:rgba(255,255,255,1);
          box-shadow:0px 4px 20px 0px rgba(238,238,238,1);
          border-radius:12*@vm_base;
          .sell_rserves_hpage_fit_order_info_block_myinfo{
            width: 100%;

            .sell_rserves_hpage_fit_order_info_block_myinfo_title{
              width: 100*@vm_base;
              height: 92*@vm_base;
              line-height: 92*@vm_base;
              float: left;
              color: #999999;
              white-space: nowrap;
            }
            .sell_rserves_hpage_fit_order_info_block_myinfo_value{
              width: calc(100% - 100*@vm_base);
              height: 92*@vm_base;
              line-height: 92*@vm_base;
              float: left;
              text-align: right;
              color: #333333;
            }
            .sell_rserves_hpage_fit_order_info_block_myinfo_value_arriveTime{
              width: calc(100% - 100*@vm_base);
              height: 92*@vm_base;
              line-height: 92*@vm_base;
              float: left;
              text-align: right;
              color: #F7B500;
              label{
                display: inline-block;
                width: 12*@vm_base;
                height: 92*@vm_base;
                float: right;
                margin-left: 8*@vm_base;
                background-image: url(../../../assets/images/base/orderArrow.png);
                background-position: center;
                background-size: 12*@vm_base auto;
                background-repeat: no-repeat;
              }
            }
            .sell_rserves_hpage_fit_order_info_block_myinfo_value_small{
              font-size: 28*@vm_base;
            }
          }
          .van-cell__title{
            color: #999999;
            font-size: 28*@vm_base;
          }
          .van-cell__value{
            font-size: 28*@vm_base;
            color: #333333;
          }
        }
      }
    }
    .sell_rserves_hpage_fit_order_price{
      padding: 40*@vm_base 32*@vm_base 0 32*@vm_base;
      .sell_rserves_hpage_fit_order_price_block{
        padding:52*@vm_base 32*@vm_base 0 32*@vm_base;
        background:rgba(255,255,255,1);
        box-shadow:0px 4px 20px 0px rgba(238,238,238,1);
        border-radius:12*@vm_base;
        .sell_rserves_hpage_fit_order_price_block_item{
          margin-top: 0*@vm_base;
          border-bottom: 1px solid #EBEBEB;
          .sell_rserves_hpage_fit_order_price_block_item_title_st{
            padding-bottom: 32*@vm_base;
            label{
              display: inline-block;
              width: 110*@vm_base;
              height: 40*@vm_base;
              line-height: 40*@vm_base;
              font-size: 22*@vm_base;
              text-align: center;
              color: #F7B500;
              border-radius:6*@vm_base;
              border:1*@vm_base solid rgba(247,181,0,1);
            }
          }
          .sell_rserves_hpage_fit_order_price_block_item_title{
            color: #999999;
          }
          .sell_rserves_hpage_fit_order_price_block_item_cont{
            color: #333333;
            .sell_rserves_hpage_fit_order_price_block_item_cont_coupon{
              width: 100%;
              text-align: right;
              padding-bottom: 32*@vm_base;
              label{
                display: inline-block;
                float: right;
                width: 32*@vm_base;
                height: 32*@vm_base;
                margin-top: 7*@vm_base;
                background-image: url(../../../assets/images/base/orderArrow.png);
                background-size: 16*@vm_base auto;
                background-repeat: no-repeat;
                background-position: center;
              }
            }
          }
        }
        .sell_rserves_hpage_fit_order_price_block_item_title_sthead{
          margin-top: 0*@vm_base;
          border-bottom: 1px solid #EBEBEB;
          .sell_rserves_hpage_fit_order_price_block_item_title_st{
            padding-bottom: 32*@vm_base;
            label{
              display: inline-block;
              width: 110*@vm_base;
              height: 40*@vm_base;
              line-height: 40*@vm_base;
              font-size: 22*@vm_base;
              text-align: center;
              color: #F7B500;
              border-radius:6*@vm_base;
              border:1*@vm_base solid rgba(247,181,0,1);
            }
          }
          .sell_rserves_hpage_fit_order_price_block_item_title{
            color: #999999;
          }
          .sell_rserves_hpage_fit_order_price_block_item_cont{
            color: #333333;
            .sell_rserves_hpage_fit_order_price_block_item_cont_coupon{
              width: 100%;
              text-align: right;
              padding-bottom: 32*@vm_base;
              label{
                display: inline-block;
                float: right;
                width: 32*@vm_base;
                height: 32*@vm_base;
                margin-top: 7*@vm_base;
                background-image: url(../../../assets/images/base/orderArrow.png);
                background-size: 16*@vm_base auto;
                background-repeat: no-repeat;
                background-position: center;
              }
            }
          }
        }
        .sell_rserves_hpage_fit_order_price_block_viprice{
          width: 100%;
          height: 36*@vm_base;
          line-height: 36*@vm_base;
          font-size: 28*@vm_base;
          text-align: right;
          .sell_rhpfopbv_label{
            color: #F7B500;
            font-size: 38*@vm_base;
            font-weight: 600;
          }
        }
        .sell_rserves_hpage_fit_order_price_block_vipriceB{
          margin-top: 8*@vm_base;
          margin-bottom: 32*@vm_base;
          color: #333333;
          // text-decoration:line-through
        }
        .sell_rserves_hpage_fit_order_price_block_vipriceC{
          margin-top: 10*@vm_base;
          // margin-bottom: 32*@vm_base;
        }
        .sell_rserves_hpage_fit_order_price_block_totalPrice{
          height: 52*@vm_base;
          line-height: 52*@vm_base;
          margin-top: 44*@vm_base;
          .sell_rserves_hpage_fit_order_price_block_totalPrice_left{
            font-size: 28*@vm_base;
            color: #333333;
            font-weight: bold;
            background-image: url(../../../assets/images/activity/miaosha/flash.png);
            background-size: auto 57*@vm_base;
            background-position: left center;
            background-repeat: no-repeat;
            // padding-left: 32*@vm_base;
          }
          .sell_rserves_hpage_fit_order_price_block_totalPrice_right{
            text-align: right;
            font-size: 36*@vm_base;
            color: #F7B500;
            font-weight: bold;
          }
        }
        .sell_rserves_hpage_fit_order_price_block_totalPrice_save{
          height: 36*@vm_base;
          line-height: 36*@vm_base;
          margin-top: 16*@vm_base;
          // margin-top: 44*@vm_base;
          margin-bottom: 40*@vm_base;
          .sell_rserves_hpage_fit_order_price_block_totalPrice_left{
            font-size: 28*@vm_base;
            color: #333333;
            font-weight: bold;
            background-image: url(../../../assets/images/activity/miaosha/flash.png);
            background-size: 25*@vm_base 36*@vm_base;
            background-position: left center;
            background-repeat: no-repeat;
            padding-left: 32*@vm_base;
          }
          .sell_rserves_hpage_fit_order_price_block_totalPrice_right{
            text-align: right;
            font-size: 36*@vm_base;
            color: #F7B500;
            font-weight: bold;
          }
        }
        .sell_rserves_hpage_fit_order_price_block_total{
          // height: 86*@vm_base;
          padding-bottom: 32*@vm_base;
          line-height: 52*@vm_base;

          .sell_rserves_hpage_fit_order_price_block_total_align{
            text-align: right;
            font-size: 28*@vm_base;
            color: #999999;
          }
          .sell_rserves_hpage_fit_order_price_block_total_align_buycard{
            width:calc(100% + 64*@vm_base);
            margin-left: -32*@vm_base;

            text-align: right;
            background:linear-gradient(90deg,rgba(242,206,136,0) 0%,rgba(242,206,136,1) 100%);
            font-weight: bold;
            font-size:28*@vm_base;
            font-weight:500;
            color:rgba(71,71,71,1);
            .sell_rserves_hpage_fit_order_price_block_total_align_buycard_vipicon{
              display: block;
              width: 36*@vm_base;
              height: 108*@vm_base;
              background-image: url(../../../assets/images/base/nocard_icon.png);
              background-size: 28*@vm_base auto;
              background-position: center;
              background-repeat: no-repeat;
              float: right;
            }
            .sell_rserves_hpage_fit_order_price_block_total_align_buycard_viptxt{
              display: block;
              padding: 29*@vm_base 20*@vm_base 29*@vm_base 4*@vm_base;
              float: right;
              font-weight: bold;
            }
            .sell_rserves_hpage_fit_order_price_block_total_align_buycard_vipprice{
              display: block;
              font-size:42*@vm_base;
              font-weight:500;
              color:rgba(71,71,71,1);
              padding: 29*@vm_base 0;
              margin-right: 12*@vm_base;
              float: right;font-weight: bold;
            }
            .sell_rserves_hpage_fit_order_price_block_total_align_buycard_right{
              display: block;
              width: 10*@vm_base;
              height: 110*@vm_base;
              background-image: url(../../../assets/images/base/nocard_right.png);
              background-size: 10*@vm_base 25*@vm_base;
              background-position: center;
              background-repeat: no-repeat;
              float: right;
              margin-right: 32*@vm_base;
            }
          }
        }
      }
    }
    .sell_rserves_hpage_fit_order_priceS{
      margin-bottom: 248*@vm_base;
    }
    .sell_rserves_hpage_fit_order_submit{
      padding: 32*@vm_base;
      height:208*@vm_base;
      background:rgba(255,255,255,1);
      position: fixed;
      bottom: 0;
      z-index: 5;
      width: 100%;
      .rserves_hpage_fit_order_submit_tips{
        width:100%;
        height:24*@vm_base;
        font-size:24*@vm_base;
        font-weight:400;
        color:#DF7027;
        line-height:24*@vm_base;
        margin-top: 24*@vm_base;
        text-align: center;
      }
      .rserves_hpage_fit_order_submit_btn{
        width:100%;
        height: 90*@vm_base;
        line-height: 90*@vm_base;
        text-align: center;
        font-size: 32*@vm_base;
        color: #FFFFFF;
        background:rgba(68,64,84,1);
        border-radius:12*@vm_base;
      }
    }
    .sell_rserves_hpage_fit_tab{
      width: 100%;
      padding: 32*@vm_base 32*@vm_base 35*@vm_base 32*@vm_base;
      background: #FFFFFF;
      // min-height: 489*@vm_base;

      .sell_rserves_hpage_fit_tab_des{
        width: 100%;
        margin-top: 32*@vm_base;
        background: #F8F8F8;
        border-radius: 6*@vm_base;
        padding: 25*@vm_base 30*@vm_base;

        font-size: 24*@vm_base;
        font-weight: 400;
        color: #333333;
      }
      .sell_rserves_hpage_fit_tab_des_Tip{
        width: 100%;
        margin-top: 18*@vm_base;
        background: #F8F8F8;
        border-radius: 6*@vm_base;
        padding: 25*@vm_base 30*@vm_base;

        font-size: 24*@vm_base;
        font-weight: 400;
        color: #333333;
      }
      .sell_rserves_hpage_fit_tab_servers{
        width: 100%;
        padding: 40*@vm_base 0*@vm_base 0*@vm_base 0*@vm_base;
        .sell_rserves_hpage_fit_tab_servers_address{
          padding-left: 32*@vm_base;
          width: 100%;
          background-image: url(../../../assets/images/activity/miaosha/posi.png);
          background-size: 20*@vm_base;
          background-position: left 5*@vm_base;
          background-repeat: no-repeat;
          font-size: 28*@vm_base;
          font-weight: 400;
          color: #444054;
        }
        .sell_rserves_hpage_fit_tab_servers_tips{
          padding-top: 40*@vm_base;
          width: 100%;
          div{
            width: calc(25% - 12*@vm_base);
            height: 72*@vm_base;
            line-height: 72*@vm_base;
            text-align: center;
            color: #333333;
            background:rgba(68,64,84,0.1);
            border-radius:6*@vm_base;
            float: left;
            margin-right: 12*@vm_base;
            margin-bottom: 12*@vm_base;
            font-size: 22*@vm_base;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
              width: 30*@vm_base;margin-right: 5*@vm_base;
              // position: absolute;
              // top: 0;
              // left: 0;
              // margin-top: 21*@vm_base;
              // margin-left: 5*@vm_base;
            }
          }
        }
      }
    }
  }
  .sell_seat{
    height: 248*@vm_base
  }
  .vt_rserves_hpage_fit_order_picktimeMask{
    background:rgba(255,255,255,1);
    position: fixed;
    bottom: 0;
    z-index: 198;
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,.3);
  }
  .vt_rserves_hpage_fit_order_picktime{
    // padding: 32*@vm_base;
    background:rgba(255,255,255,1);
    position: fixed;
    bottom: 0;
    z-index: 199;
    width: 100%;
    .van-picker__confirm{
      font-size: 16px;
    }
    .van-picker__cancel{
      font-size: 16px;
    }
  }

  // 支付成功
  .vision_payresult{
    width: 100%;
    height: calc(100vh - 90*@vm_base);
    background: #FFFFFF;
    padding-top: 88*@vm_base;
    .vision_payresult_img{
      width: 83*@vm_base;
      margin: 0 auto;
      margin-bottom: 65*@vm_base;
      border-radius: 50%;
    }
    .vision_payresult_con{
      width: 100%;
      padding: 0 48*@vm_base;
      font-size: 28*@vm_base;
      color: #444054;
    }
    .vision_payresult_tip{
      color: #DF7027;
      font-size: 24*@vm_base;
      padding: 16*@vm_base 48*@vm_base;
    }
    .vision_payresult_btn{
      width: 100%;
      padding: 56*@vm_base 48*@vm_base 0 48*@vm_base;
      .vision_payresult_btn_order{
        width: calc(50% - 17*@vm_base);
        float: left;
        height:80*@vm_base;
        line-height: 80*@vm_base;
        text-align: center;
        color: #FFFFFF;
        font-size: 32*@vm_base;
        background:linear-gradient(147deg,rgba(68,64,84,1) 0%,rgba(68,64,84,1) 100%);
        border-radius:12*@vm_base;
      }
      .vision_payresult_btn_index{
        width: calc(50% - 17*@vm_base);
        float: right;
        height:80@vm_base;
        line-height: 80*@vm_base;
        text-align: center;
        border-radius:12*@vm_base;
        border:1px solid rgba(68,64,84,1);
        color: #444054;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/activity/limitedTime/hotsellcreate.vue